import { authServices } from "authentication/services/auth.service";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faCog,
  faUserEdit,
  faKey,
} from "@fortawesome/free-solid-svg-icons";
import ToolTip, { IToolTipContentProps } from "components/Tooltip";
import HomeTooltip from "./HomeTooltip";
import SettingsTooltip from "./SettingsTooltip";
import { FullUser } from "authentication/domain/FullUser";
import UserTooltip from "./UserTooltip";
import { useAuth } from "react-oidc-context"
import config from "config/Config";
import InfoTooltip from "components/Popup/InfoTooltip";
import { FaFileExcel } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { PiDownloadLight } from "react-icons/pi";
import { useState } from "react";
import SpreadsheetLoaderModal from "./SpreadsheetLoaderModal";
import { commonService } from "Dashboard/services/common.service";
import { EXPENSES_MODULE_NAME } from "Dashboard/scenes/Expenses/domain/ExpensesModule";
import { hasFullAccessTo } from "utils/authUtil";

interface IProps {
  user: FullUser;
}

const ButtonsGroup = (props: IProps) => {
  const auth = useAuth();
  let navigate = useNavigate();
  const [isSpreadsheetLoaderOpen, setIsSpreadsheetLoaderOpen] = useState(false);

  let { user } = props;

  const onClick = () => {
    authServices.logout();
    auth.signoutRedirect({ post_logout_redirect_uri: config.HOME_URL });
  };

  return (
    <>
      <div className="button-group">
        <ToolTip
          content={HomeTooltip}
          direction="top"
          delay={1}
          style={{ left: "10%", transform: "translate(-10%)" }}
          arrowStyle={{ left: "14%" }}
        >
          {(showTip: Function) => (
            <InfoTooltip tooltip="O programu" element="span">
              <button className="btn" onClick={() => showTip()}>
                <FontAwesomeIcon icon={faHome} />
              </button>
            </InfoTooltip>
          )}
        </ToolTip>
        {user.isModuleAllowed("admin") && (
          <ToolTip
            currentUser={user}
            content={(props: IToolTipContentProps) => SettingsTooltip(props)}
            direction="right"
            style={{ left: "115%", top: "-100%" }}
            arrowStyle={{ top: "55.5%" }}
            delay={1}
            title="Podešavanja"
          >
            {(showTip: Function) => (
              <InfoTooltip tooltip="Podešavanja" element="span">
                <button className="btn" onClick={() => showTip()}>
                  <FontAwesomeIcon icon={faCog} />
                </button>
              </InfoTooltip>
            )}
          </ToolTip>
        )}
        {!user.isModuleAllowed("admin") && (
          <ToolTip
            currentUser={user}
            content={(props: IToolTipContentProps) => UserTooltip(props)}
            direction="right"
            style={{ left: "115%" }}
            delay={1}
            title="Podešavanja"
          >
            {(showTip: Function) => (
              <button className="btn" onClick={() => showTip()}>
                <FontAwesomeIcon icon={faCog} />
              </button>
            )}
          </ToolTip>
        )}
        {hasFullAccessTo(user, EXPENSES_MODULE_NAME)
          && (
            <InfoTooltip tooltip="Troškovi" element="span">
              <button className="btn" onClick={() => navigate("/expenses")}>
                <FontAwesomeIcon icon={faUserEdit} />
              </button>
            </InfoTooltip>
          )}

        {user.isModuleAllowed("data-loader") && (<InfoTooltip tooltip="Spreadsheet loader" element="span">
          <button className="btn" onClick={() => setIsSpreadsheetLoaderOpen(true)}>
            <FaFileExcel />
          </button>
        </InfoTooltip>
        )}
        {user.isModuleAllowed("data-loader") && (<InfoTooltip tooltip="Load initial data" element="span">
          <button className="btn" onClick={() => commonService.loadInitialData()}>
            <PiDownloadLight />
          </button>
        </InfoTooltip>
        )}
        {user.isModuleAllowed("data-loader") && (<InfoTooltip tooltip="Delete all data" element="span">
          <button className="btn" onClick={() => commonService.deleteAllData()}>
            <RiDeleteBin6Line />
          </button>
        </InfoTooltip>
        )}
      </div>
      <div className="logout-div">
        <span className="logout-label">Odjava </span>
        <InfoTooltip tooltip="Odjava" element="span">
          <button className="btn logout" onClick={onClick}>
            <FontAwesomeIcon icon={faKey} />
          </button>
        </InfoTooltip>
      </div>
      <SpreadsheetLoaderModal
        isOpen={isSpreadsheetLoaderOpen}
        setIsOpen={setIsSpreadsheetLoaderOpen}
      />
    </>
  );
};

export default ButtonsGroup;
